/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Company/view.blocks to change it.
import * as fromAggregate from 'Simple/Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Company({
  children,
  viewPath = "/App/ChooseUser/Users/Content/User/Company"
  
}) {
let constantData = '('
let userVaxiomPersonOrganizationNameValueData = fromData.useDataValue({ viewPath,
context: 'user',
path: 'vaxiom_person.organization.name',
})
let constantData1 = ')'
let aggregateData = fromAggregate.joinNoSpace(constantData, userVaxiomPersonOrganizationNameValueData, constantData1)
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginLeft={dtSpaceXxs}
 size="large"
 data="'('"
 data="user.vaxiom_person.organization.name"
 data="')'"
 aggregate="/Simple/Data/aggregate.js joinNoSpace"
 text={aggregateData}
/>
{children}
</React.Fragment>)
}